/* eslint-disable @typescript-eslint/quotes */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { serverUrl } from "src/app/serverUrl";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  constructor(private httpClient: HttpClient) {}

  async getCategories() {
    const url = (await serverUrl) + "open/getCategories";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async saveCategory(catId: any, catNameEng: any, catNameMar: any, flag: any) {
    const formData = new FormData();

    let body = {
      catNameEng: catNameEng,
      catNameMar: catNameMar,
    };
    if (flag === "E") {
      body["catId"], catId;
    }
    formData.append("requestDtoString", JSON.stringify(body));
    const url = (await serverUrl) + "open/saveCategory";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, formData, { responseType: "text" })
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  saveCategoryV1(catId: any, catNameEng: any, catNameMar: any, flag: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("catNameEng", `${catNameEng}`);
    queryParams = queryParams.append("catNameMar", `${catNameMar}`);
    if (flag === "E") {
      queryParams = queryParams.append("catId", catId);
    }
    return this.httpClient.post<any>(serverUrl + "open/saveCategory", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
      responseType: "text" as "json",
    });
  }
}
